window.updateCartAttributes = async function (attrs = {}) {
  return fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body: JSON.stringify({ attributes: attrs }) } }).then((r) => r.ok ? r.json() : Promise.reject(r));
};

window._fsaPersistPromise = null;
window.ensureFsaPersisted = function () {
  const apf = getFsa();
  const cofInput = document.querySelector('input[name="properties[_cof]"]');
  if (apf === "31" && cofInput) {
    cofInput.value = apf;
  };
  if (window._fsaPersistPromise) return window._fsaPersistPromise;

  window._fsaPersistPromise = fetch('/cart.js')
    .then((r) => r.json())
    .then(async (cart) => {
      const current = cart && cart.attributes ? (cart.attributes.apf || "") : "";
      console.log('%c [ current ]-27', 'font-size:13px; background:pink; color:#bf2c9f;',current, apf,String(current),String(apf))
      if (String(current) === String(apf)) return; // 已一致，不用再写
      console.log('%c [  ]-29 不一致', 'font-size:13px; background:pink; color:#bf2c9f;', )
      await window.updateCartAttributes({ apf: String(apf) });
      window.location.reload();
    })
    .catch((e) => {
      console.warn('ensureFsaPersisted failed', e);
    })
    .finally(() => {
      setTimeout(() => { window._fsaPersistPromise = null; }, 3000);
    });

  return window._fsaPersistPromise;
};

(function ensureFsaOnCartPageLoad() {
  try {
    const run = async () => {
      if (typeof window.ensureFsaPersisted !== 'function') return;
      try {
        await window.ensureFsaPersisted();
        console.log('%c [  ]-246', 'font-size:13px; background:pink; color:#bf2c9f;', )
      } catch (e) {
        console.warn('ensureFsaOnCartPageLoad error', e);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      setTimeout(run, 0);
    }
  } catch (e) {
    console.error('ensureFsaOnCartPageLoad init error', e);
  }
})();

(function () {
  'use strict';

  function parsePromo(attr) {
    // Parse JSON string or object. Handle HTML-encoded entities (&quot; -> ", etc.)
    if (!attr) return null;
    if (typeof attr === 'object') return attr;

    if (typeof attr === 'string') {
      var s = attr.trim();
      
      // Decode HTML entities
      try {
        var textarea = document.createElement('textarea');
        textarea.innerHTML = s;
        s = textarea.value;
      } catch (e) {
        // ignore
      }
      
      // Try JSON parsing
      try {
        return JSON.parse(s);
      } catch (e) {
        // Not valid JSON
        return null;
      }
    }

    return null;
  }

  function formatCurrency(value, currency) {
    if (value == null) return '';
    var locale = document.documentElement.lang || navigator.language || 'en-US';
    try {
      var formatted = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value);
      return formatted + ' ' + currency;
    } catch (e) {
      // Fallback: ensure consistent format with currency code
      var numStr = typeof value === 'number' ? value.toFixed(2) : String(value);
      return currency + ' ' + numStr + ' ' + currency;
    }
  }

  function formatCurrencySymbol(value, currency) {
    // Return formatted amount with currency symbol only (no ISO code)
    if (value == null) return '';
    var locale = document.documentElement.lang || navigator.language || 'en-US';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, currencyDisplay: 'symbol' }).format(value);
    } catch (e) {
      // Fallback: return numeric string without currency code (best-effort)
      var numStr = typeof value === 'number' ? value.toFixed(2) : String(value);
      return numStr;
    }
  }

  function findPromoInMetafields(metafieldsObj) {
    // Just return it as-is if it's an object with currency keys
    if (!metafieldsObj || typeof metafieldsObj !== 'object') return null;
    return metafieldsObj;
  }

  function detectCurrentCurrency() {
    // 从 window.Shopify.currency.active 获取当前货币
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return null;
  }

  function applyOverridesToPriceNode(priceEl) {
    if (!priceEl) return false;

    // 已经被处理过，跳过以避免重复
    if (priceEl.getAttribute('data-apf-overridden') === 'true') return false;

    var metaRaw = priceEl.getAttribute('data-me-custom');
    if (!metaRaw) return false;

    var parsedMeta = parsePromo(metaRaw);
    if (!parsedMeta) return false;

    var promo = findPromoInMetafields(parsedMeta);
    if (!promo) return false;

    // 检测当前货币
    var shopCurrency = detectCurrentCurrency();
    if (!shopCurrency) return false;

    var promoSaleParsed = parsePromo(promo);
    if (!promoSaleParsed) return false;

    // Extract price for current currency
    var overrideValue = null;
    if (typeof promoSaleParsed === 'number') {
      overrideValue = promoSaleParsed;
    } else if (typeof promoSaleParsed === 'string') {
      var maybeNum = Number(promoSaleParsed);
      if (!Number.isNaN(maybeNum)) overrideValue = maybeNum;
    } else if (typeof promoSaleParsed === 'object') {
      // 精确货币匹配
      overrideValue = promoSaleParsed[shopCurrency];
    }

    if (overrideValue == null) return false;

    var numeric = Number(overrideValue);
    if (Number.isNaN(numeric)) return false;

    var formatted = formatCurrency(numeric, shopCurrency);

    // Get original price in cents for comparison
    var priceRaw = priceEl.getAttribute('data-price');
    var compareAtRaw = priceEl.getAttribute('data-compare-at-price');
    var originalPriceCents = compareAtRaw && compareAtRaw !== '' ? parseFloat(compareAtRaw) : parseFloat(priceRaw);
    var overridePriceCents = numeric * 100;
    
    // If override price equals original price, show as regular price (not on-sale)
    if (overridePriceCents === originalPriceCents) {
      priceEl.classList.remove('price--on-sale');
      var regularEl = priceEl.querySelector('.price__regular .price-item.price-item--regular');
      if (regularEl) {
        regularEl.textContent = formatted;
      }
      var badgeSale = priceEl.querySelector('.price__badge-sale');
      if (badgeSale) {
        badgeSale.textContent = '';
      }
      priceEl.setAttribute('data-apf-overridden', 'true');
      priceEl.setAttribute('data-apf-currency', shopCurrency);
      priceEl.setAttribute('data-apf-overridden-value', numeric);
      return true;
    }

    // Prices differ: show as on-sale
    priceEl.classList.add('price--on-sale');
    var saleEl = priceEl.querySelector('.price-item--sale.price-item--last');
    var saleContainer = priceEl.querySelector('.price__sale');
    if (saleContainer) {
      saleContainer.style.display = '';
    }
    if (saleEl) {
      saleEl.textContent = formatted;
    }

    // Update strikethrough price with original formatted price
    var strikeEl = priceEl.querySelector('.price__sale s.price-item--regular');
    if (strikeEl) {
      var formattedOriginal = formatCurrency(originalPriceCents / 100, shopCurrency);
      strikeEl.textContent = formattedOriginal;
    }

    // Update badge with savings amount
    var badgeSale = priceEl.querySelector('.price__badge-sale');
    if (badgeSale && originalPriceCents > 0) {
      var savingAmount = originalPriceCents / 100 - numeric;
      if (savingAmount > 0) {
        var savingFormatted = formatCurrencySymbol(savingAmount, shopCurrency);
        badgeSale.textContent = 'Save ' + savingFormatted + ' ';
      } else {
        badgeSale.textContent = '';
      }
    }

    // mark override active and store overridden value - 先标记避免无限循环
    priceEl.setAttribute('data-apf-overridden', 'true');
    priceEl.setAttribute('data-apf-currency', shopCurrency);  // 记录处理时的货币
    priceEl.setAttribute('data-apf-overridden-value', numeric);
    return true;
  }

  function applyAllOverrides() {
    var apfParam = getFsa();
    if (apfParam !== '31') return;
    var nodes = document.querySelectorAll('.price[data-me-custom]:not([data-apf-overridden="true"])');
    nodes.forEach(function (el) {
      applyOverridesToPriceNode(el);
    });
  }

  // apply on load
  document.addEventListener('DOMContentLoaded', function () {
    applyAllOverrides();
  });

  // re-apply when history navigation occurs
  window.addEventListener('popstate', function () { 
    setTimeout(applyAllOverrides, 50); 
  });

  // observe DOM changes (e.g., AJAX replacement from global.js) and reapply
  var observer = new MutationObserver(function (mutations) {
    var changed = false;
    var removedNodes = [];
    
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        changed = true;
        // Collect removed nodes
        for (var j = 0; j < m.removedNodes.length; j++) {
          removedNodes.push(m.removedNodes[j]);
        }
      }
    }
    
    if (changed) {
      // Clear marks only for removed price elements
      removedNodes.forEach(function (node) {
        if (node.nodeType === 1) { // Element node
          var prices = node.querySelectorAll ? node.querySelectorAll('.price[data-apf-overridden="true"]') : [];
          prices.forEach(function (el) {
            el.removeAttribute('data-apf-overridden');
            el.removeAttribute('data-apf-currency');
            el.removeAttribute('data-apf-overridden-value');
          });
        }
      });

      // Debounce re-application
      if (window.__priceOverrideTimeout) clearTimeout(window.__priceOverrideTimeout);
      window.__priceOverrideTimeout = setTimeout(function () {
        applyAllOverrides();
      }, 100);
    }
  });

  observer.observe(document.documentElement || document.body, { childList: true, subtree: true });

  /* --- Globo swatch integration: listen for swatch/select changes and reapply overrides --- */
  function getVariantIdFromSwatchElement(el) {
    if (!el) return null;
    // If it's a select (globo-selector-all), its value is the variant id
    if (el.tagName === 'SELECT' && el.value) return el.value;

    // If it's an input (radio), try to parse variant id from id or value
    if (el.tagName === 'INPUT') {
      if (el.value && /^\d+$/.test(el.value)) return el.value;
      if (el.id) {
        var m = el.id.match(/(\d{6,})/);
        if (m) return m[1];
      }
    }

    // try to find a select within same wrapper
    var sel = el.closest && el.closest('.swatches-globo--list, .swatches-globo, .globo-swatch-list') ? (el.closest('.swatches-globo--list') || el.closest('.swatches-globo') || el.closest('.globo-swatch-list')) : null;
    if (sel) {
      var selectEl = sel.querySelector && sel.querySelector('.globo-selector-all');
      if (selectEl && selectEl.value) return selectEl.value;
    }

    return null;
  }

  function handleGloboSwatchEvent(e) {
    try {
      var t = e.target;
      // Accept inputs, selects, and label anchors
      if (!t) return;

      // find wrapper that contains product id
      var wrapper = t.closest('[globo-product-swatch-id], [product-selector], .globo-swatch-product-item, .swatches-globo--list, .swatches-globo');
      if (!wrapper) return;

      var productId = wrapper.getAttribute && (wrapper.getAttribute('globo-product-swatch-id') || wrapper.getAttribute('product-selector') || wrapper.getAttribute('product-swatch-id'));
      if (!productId) {
        // try parent card
        var card = wrapper.closest && wrapper.closest('.card__content');
        if (card) productId = card.querySelector && (card.querySelector('.price') && card.querySelector('.price').getAttribute('data-product-id'));
      }
      if (!productId) return;

      // variant id
      var variantId = getVariantIdFromSwatchElement(t) || (wrapper.querySelector && (wrapper.querySelector('.globo-selector-all') ? wrapper.querySelector('.globo-selector-all').value : null));

      // fallback: find selected radio input within wrapper
      if (!variantId) {
        var checked = wrapper.querySelector && wrapper.querySelector('input[type="radio"]:checked');
        if (checked) variantId = getVariantIdFromSwatchElement(checked);
      }

      var priceEl = document.querySelector('.price[data-product-id="' + productId + '"]');
      if (!priceEl) return;

      // update data-variant-id if found
      if (variantId) {
        priceEl.setAttribute('data-variant-id', variantId);
      }

      // Clear existing override marks so applyOverrides runs
      priceEl.removeAttribute('data-apf-overridden');
      priceEl.removeAttribute('data-apf-overridden-value');
      priceEl.removeAttribute('data-apf-currency');

      // run override (use small timeout to allow plugin to update any related DOM first)
      setTimeout(function () {
        try { applyOverridesToPriceNode(priceEl); } catch (err) { console.warn('applyOverridesToPriceNode error', err); }
      }, 20);
    } catch (err) {
      console.warn('handleGloboSwatchEvent error', err);
    }
  }

  // Scoped bindings: only bind handlers to swatch containers that sit next to a price with our promo data
  function bindHandlersToWrapper(wrapper) {
    if (!wrapper || wrapper.__apfBound) return;
    wrapper.__apfBound = true;

    wrapper.addEventListener('change', function (e) {
      if (!e.target) return;
      if (e.target.matches('.globo-selector-all') || e.target.matches('input[type="radio"]')) {
        if (getFsa() !== '31') return;
        handleGloboSwatchEvent(e);
      }
    }, { passive: true });

    wrapper.addEventListener('click', function (e) {
      var anchor = e.target.closest && e.target.closest('.swatch-anchor, .swatch--gl, .globo-swatch-list .swatch-anchor');
      if (anchor) {
        if (getFsa() !== '31') return;
        setTimeout(function () { handleGloboSwatchEvent({ target: anchor }); }, 30);
      }
    }, { passive: true });
  }

  function initSwatchBindings() {
    // Only bind when the feature flag is active
    if (getFsa() !== '31') return;
    var candidates = document.querySelectorAll('.swatches-globo--list, .swatches-globo, .globo-swatch-list, [globo-product-swatch-id], .globo-swatch-product-item');
    candidates.forEach(function (c) {
      try {
        // Only bind when a nearby .price with our promo data exists (opt-in)
        var card = c.closest && c.closest('.card__content');
        var priceEl = null;
        if (card) priceEl = card.querySelector && card.querySelector('.price[data-me-custom]');
        if (!priceEl) {
          // fallback: search within ancestor chain
          priceEl = c.parentElement && c.parentElement.querySelector && c.parentElement.querySelector('.price[data-me-custom]');
        }
        if (priceEl) bindHandlersToWrapper(c);
      } catch (e) {
        // ignore
      }
    });
  }

  // initialize bindings on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchBindings, { once: true });
  } else {
    setTimeout(initSwatchBindings, 0);
  }

  // ensure we re-scan for new wrappers when observer triggers re-application
  var __oldApplyAll = applyAllOverrides;
  applyAllOverrides = function () {
    __oldApplyAll();
    try { initSwatchBindings(); } catch (e) { /* ignore */ }
  };

})();
